module.exports = (__webpack_require__(0))(52);


//////////////////
// WEBPACK FOOTER
// delegated ./src/utilities/EventStream.js from dll-reference girder_lib
// module id = 78
// module chunks = 0